import { all, call, put, race, select, take, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import config from '../../../../../../../../../../../../../../../config'

import {
    LOAD_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE,
    DATA_REQUEST,
    REMOVE_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE,
} from './constants'

import { loadDataTableRequest } from './actions'
import { blockSaveCustomData } from '../../../../../../../../../../../../../components/Workspace/components/HocBlock/actions'

import { localeSelector, tokenSelector, customDataSelector } from './selectors'

const MODULE_KEY = config.modules.report.key
const BLOCK_KEY = config.modules.report.blocks.estates.key

function* loadDataTable(id, listId, objectId) {
    const token = yield select(tokenSelector, id)
    if (!token) return null

    let customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            ownershipListEstateDetail: {
                ..._.get(customData, 'ownershipListEstateDetail', {}),
                [listId]: {
                    ..._.get(customData, `ownershipListEstateDetail.${listId}`, {}),
                    [objectId]: {
                        ..._.get(customData, `ownershipListEstateDetail.${listId}.${objectId}`, {}),
                        isLoading: true,
                    },
                },
            },
        })
    )

    const locale = yield select(localeSelector)

    const result = yield all({
        response: race({
            success: take(`${DATA_REQUEST(MODULE_KEY, id, BLOCK_KEY, listId, objectId)}_${SUCCESS}`),
            failed: take(`${DATA_REQUEST(MODULE_KEY, id, BLOCK_KEY, listId, objectId)}_${FAILED}`),
        }),
        request: put(
            loadDataTableRequest(MODULE_KEY, id, BLOCK_KEY, listId, objectId, {
                lang: locale,
                token,
            })
        ),
    })

    const data = _.get(result, 'response.success.payload.response.body', null)

    if (result.response.failed || !data) return null
    customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            ownershipListEstateDetail: {
                ..._.get(customData, 'ownershipListEstateDetail', {}),
                [listId]: {
                    ..._.get(customData, `ownershipListEstateDetail.${listId}`, {}),
                    [objectId]: {
                        ..._.get(customData, `ownershipListEstateDetail.${listId}.${objectId}`, {}),
                        isLoading: false,
                        isLoaded: true,
                        data,
                    },
                },
            },
        })
    )

    return null
}

function* onLoadDataTable(_action) {
    const id = _.get(_action, 'data.id', null)
    const listId = _.get(_action, 'data.listId', null)
    const objectId = _.get(_action, 'data.objectId', null)
    if (!id || !listId || !objectId) return null

    yield call(loadDataTable, id, listId, objectId)

    return null
}

function* onRemoveDataTable(_action) {
    const id = _.get(_action, 'data.id', null)
    const listId = _.get(_action, 'data.listId', null)
    const objectId = _.get(_action, 'data.objectId', null)
    if (!id || !listId || !objectId) return null

    const customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            ownershipListEstateDetail: _.omitBy(
                {
                    ..._.get(customData, 'ownershipListEstateDetail', {}),
                    [listId]: _.omit(_.get(customData, `ownershipListEstateDetail.${listId}`, {}), [objectId]),
                },
                _.isEmpty
            ), // remove empty listId objects
            ownershipListEstateDetailRow: _.omitBy(
                {
                    ..._.get(customData, 'ownershipListEstateDetailRow', {}),
                    [listId]: _.omit(_.get(customData, `ownershipListEstateDetailRow.${listId}`, {}), [objectId]),
                },
                _.isEmpty
            ), // remove empty listId objects
        })
    )

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(LOAD_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE, onLoadDataTable),
        takeEvery(REMOVE_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE, onRemoveDataTable),
    ])
}
